import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import DataParser from "../../../utlits/Dataparser";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import { Helmet } from "react-helmet";
import StatusBadge from "../../Reuseable/StatusBadge";
import JobStatusService from "../../../Services/JobStatusService";
import secureLocalStorage from "react-secure-storage";
import SocketService from "../../../Services/SocketService";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const JobStatus = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [JobStatus, setJobStatus] = useState([]);
  const [userPermissions, setuserPermissions] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [jobStatusName, setJobStatusName] = useState("");
  const [jobStatusNameEdit, setJobStatusNameEdit] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);
  const [editID, setEditID] = useState("");
  const companyId = DataParser.CompanyId();

  useEffect(() => {
    if (pageSize > 15) {
      setCurrentPage(1);
    }
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getJobss = () => {
    setIsLoading(true);
    const companyId = DataParser.CompanyId();

    JobStatusService.getJobStatusService(companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        const dataset = res.data?.jobstatus || [];
        setJobStatus(dataset);
      })
      .catch((err) => {
        console.error("Error fetching job statuses:", err);
        message.error("Failed to load employment statuses. Please try again!");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getJobss();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();
    const handleJobStatusUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        getJobss();
      }
    };
    SocketService.on("jobstatus_update", handleJobStatusUpdate);
    return () => {
      SocketService.off("jobstatus_update", handleJobStatusUpdate);
    };
  }, []);

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeleteJobStatusModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const id = itemToDelete.id;
    const newData = JobStatus.filter((el) => el.id !== id);
    setJobStatus(newData);
    document.getElementById("closeJobStatusDeleteModal").click();
    try {
      const res = await JobStatusService.deleteJobStatus(id);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      } else {
        message.success("Employment status deleted successfully!");
      }
      getJobss();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete employment status. Please try again!");
      getJobss();
    }
    setItemToDelete(null);
  };

  const handleOpenUpdate = (e, item) => {
    e.preventDefault();
    setJobStatusNameEdit(item.name);
    setEditID(item.id);
  };

  const handelSubmit = (e) => {
    e.preventDefault();

    if (!jobStatusName || jobStatusName.trim() === "") {
      setError("Status name is required!");
      return;
    }

    const AddData = {
      name: jobStatusName.trim(),
      company_id: companyId,
    };

    JobStatusService.createJobStatus(AddData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.Good === true) {
          message.success("Employment status created successfully!");
          const link = document.getElementById("JobStatusModalCreate");
          if (link) link.click();
          getJobss();
          setJobStatusName("");
        } else {
          message.warning("Failed to create employment status. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error creating job status:", err);
        message.error(
          err.response?.data?.message ||
          "An unexpected error occurred while creating the employment status."
        );
      });
  };

  const clearCreateState = () => {
    setJobStatusName("");
    setError("");
  };

  const clearEditState = () => {
    setJobStatusNameEdit("");
    setEditID("");
    setError("");
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();

    if (!jobStatusNameEdit || jobStatusNameEdit.trim() === "") {
      setError("Status name is required!");
      return;
    }

    const AddData = {
      name: jobStatusNameEdit.trim(),
    };

    JobStatusService.editJobStatus(editID, AddData)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.Good === true) {
          message.success("Employment status updated successfully!");
          const link = document.getElementById("JobStatusModalEdit");
          if (link) link.click();
          getJobss();
        } else {
          message.warning("Failed to update employment status. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error updating job status:", err);
        message.error(
          err.response?.data?.message ||
          "An unexpected error occurred while updating the employment status."
        );
      });
  };

  const PaginatedData = paginate(JobStatus, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Employment Status - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Employment Status</li>
                    </ol>
                    {userPermissions.indexOf("jobstatus-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createJobStatusModal"
                      >
                        Create Employment Status
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Employment Status
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={4} rows={6} />
                          ) : (
                            <>
                              {PaginatedData && PaginatedData.length > 0 ? (
                                PaginatedData.map((item, index) => (
                                  <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    <td>
                                      {userPermissions.indexOf("jobstatus-edit") !== -1 ? (
                                        <StatusBadge
                                          item={item}
                                          api={JobStatusService.updateJobStatusStatus}
                                        />
                                      ) : (
                                        <>
                                          {item.status === "1" ? (
                                            <span className="badge bg-success text-white">Active</span>
                                          ) : (
                                            <span className="badge bg-danger text-white">Deactive</span>
                                          )}
                                        </>
                                      )}
                                    </td>
                                    <td className="tableset">
                                      {userPermissions.indexOf("jobstatus-delete") !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handelDelete(e, item)}
                                        >
                                          <Tooltip title="Delete Employment Status">
                                            <i className="uil-trash iconscolor" />
                                          </Tooltip>
                                        </Link>
                                      ) : (
                                        <span
                                          className="uil-trash iconscolor text-muted"
                                          style={{ cursor: "not-allowed", opacity: 0.5 }}
                                          title="You don't have permission to delete"
                                        />
                                      )}
                                      {userPermissions.indexOf("jobstatus-edit") !== -1 ? (
                                        <Link
                                          to="#"
                                          className="cursor-pointer iconscolor"
                                          onClick={(e) => handleOpenUpdate(e, item)}
                                          data-bs-toggle="modal"
                                          data-bs-target="#editJobStatusModal"
                                        >
                                          <Tooltip title="Edit Employment Status">
                                            <i className="uil-pen iconscolor" />
                                          </Tooltip>
                                        </Link>
                                      ) : (
                                        <span
                                          className="uil-pen iconscolor text-muted"
                                          style={{ cursor: "not-allowed", opacity: 0.5 }}
                                          title="You don't have permission to edit"
                                        />
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="12" className="text-center">
                                    Add your first employment status by clicking the 'Create Employment Status' button.
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>

                      {JobStatus.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={JobStatus.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <div id="openDeleteJobStatusModal" data-bs-toggle="modal" data-bs-target="#deleteJobStatusModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deleteJobStatusModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Employment Status</h5>
                <button type="button" className="btn-close" id="closeJobStatusDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this employment status?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create modal */}
        <div
          id="createJobStatusModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Employment Status</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="JobStatusModalCreate"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearCreateState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="Name"
                      placeholder=" "
                      value={jobStatusName}
                      onChange={(e) => {
                        setJobStatusName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="Name">Status Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    onClick={(e) => handelSubmit(e)}
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Status
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit modal */}
        <div
          id="editJobStatusModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelEditSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Employment Status</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="JobStatusModalEdit"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearEditState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="NameEdit"
                      placeholder=" "
                      value={jobStatusNameEdit}
                      onChange={(e) => {
                        setJobStatusNameEdit(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="NameEdit">Status Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    onClick={(e) => handelEditSubmit(e)}
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default JobStatus;
